import { ApolloClient, InMemoryCache } from '@apollo/client';
import { REAL_SERVER } from 'config';

export const client = new ApolloClient({
  uri: REAL_SERVER,
  cache: new InMemoryCache(),
});
